import { Button } from "@root/shared/components/Button";
import { ChoiceChip } from "@root/shared/components/ChoiceChip";
import { GroupedChoiceChip } from "@root/shared/components/GroupedChoiceChip";
import { ModalTrigger } from "@root/shared/components/ModalTrigger";
import { Heading } from "@userFrontend/components/Heading";
import * as styles from "./styles.css";
import { type ChoiceGroup, type Choice } from "../../../types";

export type AreaModalProps = {
  isActionButtonDisabled?: boolean;
  title: string;
  values: string[];
  onChange: (values: string[]) => void;
  choiceGroups: ChoiceGroup[];
  popularAreaValues: string[];
  onPopularAreaChange: (values: string[]) => void;
  popularAreaChoices: Choice[];
  defaultIsOpened: boolean;
};

export const AreaModal = (props: AreaModalProps) => {
  const {
    isActionButtonDisabled,
    title,
    values,
    onChange,
    choiceGroups,
    popularAreaValues,
    onPopularAreaChange,
    popularAreaChoices,
    defaultIsOpened,
  } = props;

  const handleGroupChange = (groupName: string, newValues: string[]) => {
    const currentGroup = choiceGroups.find((group) => group.groupName === groupName);
    const currentGroupValuesSet = new Set([
      ...(currentGroup?.choices.map((choice) => choice.value) ?? []),
      ...(currentGroup?.value ? [currentGroup.value] : []),
    ]);
    const updatedValues = Array.from(
      new Set([...values.filter((value) => !currentGroupValuesSet.has(value)), ...newValues]),
    );
    onChange(updatedValues);
  };

  return (
    <ModalTrigger
      headerTitle={title}
      footerContentStyle="button"
      renderAction={(open) => (
        <Button
          theme="secondary"
          onClick={open}
          disabled={isActionButtonDisabled}
          className={styles.selectButton}
        >
          {title}
        </Button>
      )}
      renderFooterContent={(close) => (
        <div className={styles.footerButtonWrapper}>
          <Button type="button" theme="secondary" onClick={close}>
            戻る
          </Button>
        </div>
      )}
      spAppearanceType="bottom"
    >
      <div className={styles.modalContentsInner}>
        {popularAreaChoices.length > 0 && (
          <div className={styles.popularAreaChoicesWrapper}>
            <div className={styles.headingWrapper}>
              <Heading tag="p" size="small">
                人気のエリアを選択
              </Heading>
            </div>
            <ChoiceChip
              values={popularAreaValues}
              onChange={onPopularAreaChange}
              choices={popularAreaChoices}
            />
          </div>
        )}
        {choiceGroups.length > 0 && (
          <div className={styles.groupedChoiceChipsWrapper}>
            {choiceGroups.map((group, index) => (
              <div key={group.groupName} className={styles.groupedChoiceChipWrapper}>
                <GroupedChoiceChip
                  title={group.groupName}
                  id={`${group.groupName}-${index}`}
                  values={values.filter(
                    (value) =>
                      group.choices.some((choice) => choice.value === value) ||
                      group.value === value,
                  )}
                  groupValue={group.value}
                  onChange={(newValues) => handleGroupChange(group.groupName, newValues)}
                  choices={group.choices}
                  defaultIsOpened={defaultIsOpened}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </ModalTrigger>
  );
};
